import { DatabaseZap, GitCompareArrowsIcon, Waypoints, RefreshCwIcon } from "lucide-react";
import CavOfflineSyncRoutes from "@/pages/it/cav-offline-sync/cav-offline-sync.routes";
import { RoleEnum } from "../../../../src/enum/role";
import UpdatesControlRoutes from "@/pages/it/updates-control/updates-control.route";
import { GroupsEnum } from "@/enum/groups";
import UpdatesConnectionsRoutes from "@/pages/it/updates-connections/updates-connections-route";
import UpdatesRequestRoutes from "@/pages/it/updates-request/update.route";
import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";

const isCavOfflineSyncEnabled = import.meta.env.VITE_CAV_OFFLINE_SYNC_ENABLED === "true";

export const itRoutes = [
  createRoute({
    id: "Requisição de Query",
    category: "Updates no Banco",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.TI],
    path: "/requisicao-de-query/*",
    pathId: PATH_IDS.TI,
    element: <UpdatesRequestRoutes />,
    Icon: DatabaseZap,
  }),
  createRoute({
    id: "Lista de Aprovação",
    category: "Updates no Banco",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.TI],
    path: "/lista-de-aprovacao/*",
    pathId: PATH_IDS.TI,
    element: <UpdatesControlRoutes />,
    Icon: GitCompareArrowsIcon,
  }),
  createRoute({
    id: "Controle de Conexões",
    category: "Updates no Banco",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.TI],
    path: "/controle-de-conexoes/*",
    pathId: PATH_IDS.TI,
    element: <UpdatesConnectionsRoutes />,
    Icon: Waypoints,
  }),
  ...(isCavOfflineSyncEnabled
    ? [
        createRoute({
          id: "Sincronizacao CAV Offline",
          category: "CAV",
          requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
          groupRequired: [GroupsEnum.TI],
          path: "/cav-offline-sync/*",
          pathId: PATH_IDS.TI,
          element: <CavOfflineSyncRoutes />,
          Icon: RefreshCwIcon,
        }),
      ]
    : []),
];
